module.exports = __webpack_public_path__ + "icon_discussion_green.png?5dd4c125ca14e8c465a5fd66c1c4a48e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_discussion_green.png
// module id = 252
// module chunks = 0